<template>
  <vs-popup
    id="branchProductReportViewer"
    :active.sync="isActive"
    :title="(report.type ? report.type.dName : null) + ' Şube Raporu'"
    v-esc="escape"
  >
    <vs-row vs-type="flex" vs-w="12" v-if="Object.keys(report).length > 0">
      <vs-col vs-type="flex" vs-w="3">
        <vs-row vs-type="block" vs-w="12">
          <vs-row vs-type="flex" class="mb-2 justify-center" vs-w="12">
            <vs-button
              class="vx-col w-full px-4 py-1 category-product responsive sale-box-shadow"
              color="transparent"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12" class="px-4 py-2">
                  <vs-col vs-type="flex" vs-w="12" vs-justify="center">
                    <div class="flex items-center justify-center">
                      <img
                        :src="getImage(report.accordingTo.imageUrl)"
                        class="responsive"
                        alt="accordingTo"
                      />
                    </div>
                  </vs-col>
                </vs-row>
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  class="bg-white category-product-name-row px-1 py-2"
                >
                  <vs-col vs-type="flex" vs-w="12" vs-justify="center">
                    <p
                      class="text-smaller block text-primary weight-600 category-product-name"
                    >
                      {{ report.accordingTo.typeValue }}
                    </p>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-button>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="border-all border-radius border-secondary p-2">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="12" vs-justify="space-between">
              <span class="text-dark text-small weight-600">
                {{ report.quantityType === 1 ? 'Toplam Süre' : 'Toplam Adet' }}
              </span>
                <span class="text-primary text-small weight-600">
                {{ report.accordingTo.piece.toLocaleString() }} {{ report.quantityType === 1 ? 'dk' : 'Adet' }}
              </span>
              </vs-col>
            </vs-row>
            <vs-divider class="my-1"></vs-divider>
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="12" vs-justify="space-between">
              <span class="text-dark text-small weight-600">
                Toplam Tutar
              </span>
                <span class="text-primary text-small weight-600">
                {{ $toCurrency(report.accordingTo.amount) }}
              </span>
              </vs-col>
            </vs-row>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <vs-row vs-type="flex" vs-w="12" v-for="size in report.variantSums" :key="size.sizeId"
                    class="border-all border-secondary py-1 px-2 border-radius text-smaller my-1">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row vs-type="flex" vs-w="12" class="border-bottom">
                      <vs-col vs-type="flex" vs-w="4">
                        <span class="text-primary bold">{{ size.sizeName }}</span>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="4">
                      <span>
                        {{ report.quantityType === 1 ? 'Süre (dk)' : 'Adet' }}
                      </span>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="4">
                      <span>
                        Tutar
                      </span>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" v-for="variant in size.variants" :key="variant.variantId" class="my-1">
                <vs-col vs-type="flex" vs-w="4">
                  <span class="weight-600">
                    {{ variant.variantName }}
                  </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <span>
                    {{ variant.variantPiece.toLocaleString() }}
                  </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <span>
                    {{ $convertCurrency(variant.variantAmount) }}
                  </span>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <vs-col vs-type="flex" vs-w="4">
                  <span class="text-primary bold">
                    Toplam
                  </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                <span class="weight-500">
                  {{ size.sizePiece.toLocaleString() }}
                </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <span class="bold">
                    {{ $convertCurrency(size.sizeAmount) }}
                  </span>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-w="9" class="pl-3">
        <vs-row vs-type="block" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" class="py-1" vs-align="center">
            <vs-col vs-type="flex" vs-w="8" class="pr-1">
              <span class="text-secondary text-medium-small weight-600">
                {{ report.date.toLocaleString() }}
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="4" class="pl-1" vs-justify="flex-end">
              <vx-tooltip title="Excel Export"
                          position="top">
                <vs-button @click="getExcel(report.accordingTo.typeId)" color="primary" type="gradient"
                           icon-pack="feather" icon="icon-download" />
              </vx-tooltip>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="productReportFilter" class="my-2">
            <vs-input v-model="filterString" class="w-full border-radius border-all"
                      :placeholder="(report.type ? report.type.dName : null) + ' Arama'"/>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="categoryReportRest">
            <vs-collapse class="w-full">
              <vs-collapse-item v-for="(row,index) in (filteredList && filteredList.length > 0 ? filteredList : [])" :key="index"
                @click.native="() => onClick(row.branch.id)">
                <div slot="header">
                  <vs-row vs-type="flex" vs-w="12" class="py-1">
                    <div class="d-flex w-full justify-between border-bottom border-secondary py-1">
                      <vs-col vs-type="flex" vs-w="5" vs-align="center">
                  <span class="text-primary mr-2 text-xsmall weight-600">
                    {{ (index + 1) + '.' }}
                  </span>
                        <span class="text-primary text-xsmall weight-600">
                     {{ row.branch.name }}
                  </span>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="3" vs-align="center">
                  <span class="text-secondary weight-600 text-xsmall w-full text-center">
                    {{ report.orderBy === 0 ? (row.quantity.toLocaleString() + (report.quantityType === 1 ? ' dk' : ' Adet')) : $convertCurrency(row.amount) }}
                  </span>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="3.5" vs-align="center">
                  <span class="text-primary weight-600 text-xsmall w-full text-center">
                    {{ report.orderBy === 1 ? (row.quantity.toLocaleString() + (report.quantityType === 1 ? ' dk' : ' Adet')) : $convertCurrency(row.amount) }}
                  </span>
                      </vs-col>
                    </div>
                  </vs-row>
                </div>
                <vs-row vs-type="flex" vs-w="12" v-for="size in row.sizes" :key="size.sizeId"
                        class="border-all border-secondary py-1 px-2 border-radius text-smaller my-1">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col vs-type="flex" vs-w="12">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12" class="border-bottom">
                          <vs-col vs-type="flex" vs-w="4">
                            <span class="text-primary bold">{{ size.sizeName }}</span>
                          </vs-col>
                          <vs-col vs-type="flex" vs-w="4">
                      <span>
                         {{ report.quantityType === 1 ? 'Süre (dk)' : 'Adet' }}
                      </span>
                          </vs-col>
                          <vs-col vs-type="flex" vs-w="4">
                      <span>
                        Tutar
                      </span>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" v-for="variant in size.variants" :key="variant.variantId" class="my-1">
                    <vs-col vs-type="flex" vs-w="4">
                  <span class="weight-600">
                    {{ variant.variantName }}
                  </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4">
                  <span>
                    {{ variant.variantPiece.toLocaleString() }}
                  </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4">
                  <span>
                    {{ $convertCurrency(variant.variantAmount) }}
                  </span>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" class="mt-1">
                    <vs-col vs-type="flex" vs-w="4">
                  <span class="text-primary bold">
                    Toplam
                  </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4">
                <span class="weight-500">
                  {{ size.sizePiece.toLocaleString() }}
                </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4">
                  <span class="bold">
                    {{ $convertCurrency(size.sizeAmount) }}
                  </span>
                    </vs-col>
                  </vs-row>
                </vs-row>
              </vs-collapse-item>
            </vs-collapse>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row></vs-row>
  </vs-popup>
</template>

<script>
export default {
  name: "BranchProductReportViewer",
  props: {
    report: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isActive: false,
      filterString: null,
    };
  },
  computed: {
    filteredList() {
      if (!this.filterString) return this.report.list
      return this.report.list.filter(x => x.branch.name.toLowerCase().includes(this.filterString.toLowerCase()))
    }
  },
  methods: {
    onClick(id){
      if (this.report.type.name == "Category" || this.report.type.name == "Product") {
        this.$emit("openVariantPopup",id,this.report.accordingTo.typeId)
      }
    },
    getExcel(id) {
      this.$emit("getExcel", id)
    },
    escape() {
      if (this.isActive) this.isActive = false;
    },
    getImage(image) {
      if (!image) return this.$productImage;
      else return this.$baseUrl + "/" + image;
    },
  },
  watch: {
    isActive(val) {
      if (!val) this.$emit("close");
    },
  },
};
</script>

<style>
.category-product-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.category-product .vs-button--text {
  display: inline !important;
}

.category-product {
  max-width: 175px;
  border-radius: 18px;
  padding: 0 !important;
  border: 1px solid #00000050;
}

.category-product img {
  max-width: 135px !important;
  max-height: 135px !important;
}

.category-product-name-row {
  border-top: 1px solid #00000050;
}

#branchProductReportViewer .vs-popup {
  width: 70vw !important;
}

#branchProductReportViewer .vs-collapse-item--header {
  padding: 0!important;
}
#branchProductReportViewer .vs-collapse.default .open-item .con-content--item{
  padding: 0!important;
}
</style>
